import { render } from "./edit.vue?vue&type=template&id=284750bc&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import "./edit.vue?vue&type=style&index=0&id=284750bc&style=scss&scoped=true&lang=css"

import exportComponent from "D:\\消防\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-284750bc"],['__file',"src/views/branch/staff/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "284750bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('284750bc', __exports__)) {
    console.log('reload')
    api.reload('284750bc', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=284750bc&scoped=true", () => {
    console.log('re-render')
    api.rerender('284750bc', render)
  })

}


export default __exports__